import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h6","key":"svg-2"}]]

const IconFilter2 = createReactComponent('outline', 'filter-2', 'Filter2', __iconNode);

export default IconFilter2;